import { toggleCart, reRenderShopifySections } from 'utils/shopify'
import { getCartSections } from 'utils/requests'

// The account drawer's quick add posts to /cart/add itself and reports only `added` in CART_UPDATED,
// so nothing re-renders the bag or the header count until a reload (41426146). Theme adds always send
// `items` and render their own sections. This runs here, not in the cart drawer, because that component
// only loads the first time the bag opens.
document.addEventListener('CART_UPDATED', async ({ detail }) => {
  if (!detail?.added || detail.items) return

  reRenderShopifySections(await getCartSections())
})

// The toast after that add links to /cart, which reloads the page and opens the bag on load. Focus moved
// there before any click shows a focus ring on the bag's close button, and then on the header bag icon
// once it closes (41426186). Open the bag on this page instead.
const openBagFromToast = (event, root) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return

  const link = event.composedPath().find(el => el.matches?.('.gw-notification__link'))
  if (!link) return

  event.preventDefault()
  root.querySelector('[data-notification-alert]')?.hide?.()

  const bagToggle = [...document.querySelectorAll('[data-cart-toggle]')].find(el => el.checkVisibility?.() !== false)
  let opened = false
  const openBag = () => {
    if (opened) return
    opened = true
    toggleCart(true, bagToggle)
  }

  const drawer = root.querySelector('sl-drawer[main-drawer]')
  if (!drawer?.open) {
    openBag()
    return
  }

  // Let the account drawer finish closing and hand focus back before the bag takes it.
  drawer.addEventListener('sl-after-hide', openBag, { once: true })
  setTimeout(openBag, 600)
  root.querySelector('[data-main-drawer-close]')?.click()
}

customElements.whenDefined('gw-customer-accounts').then(() => {
  const root = document.querySelector('gw-customer-accounts')?.shadowRoot
  root?.addEventListener('click', event => openBagFromToast(event, root))
})
